import { createSlice } from "@reduxjs/toolkit";
import { getBookingIdDetailsAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getBookingSlice = createSlice({
  name: "getBooking",
  initialState: data,
  reducers: {
   getBookingSlice(state) {
      state.isLoading = true;
    },
   getBookingSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getBookingSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getBookingSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getBookingDetailHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getBookingAction.getBookingSlice());
    const response: any = await getBookingIdDetailsAPI(id);
    
    dispatch(getBookingAction.getBookingSliceSuccess(response));
  } catch (e: any) {
    dispatch(getBookingAction.getBookingSliceFailure(e?.response?.data));
  }
};
export default getBookingSlice.reducer;
export const getBookingAction = getBookingSlice.actions;
